<template>
    <div class="box" v-for="notificationOrder in notificationOrders" :key="notificationOrder.id">
        <div class="is-flex is-justify-content-space-evenly mb-3">
            <div>
                <span class="is-description is-size-5"> {{ translate("notification_center.listing_item.notification_type") }}: </span>
                <span class="is-size-5">
                    {{ translateType(notificationOrder.notificationType) }}
                </span>
                <span class="is-size-7">({{ notificationOrder.shortId }})</span>
            </div>
            <div>
                <span class="is-size-5" :class="getStatusClass(notificationOrder.status)">
                    {{ translateStatus(notificationOrder.status) }}
                </span>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="is-flex is-justify-content-space-around is-flex-wrap-wrap">
                    <div>
                        <span class="is-description"> {{ translate("notification_center.listing_item.created") }}: </span>
                        {{ formatCreatedAt(notificationOrder.created) }}
                    </div>
                    <div>
                        <span class="is-description"> {{ translate("notification_center.listing_item.status.start") }}: </span>
                        {{ formatStartAt(notificationOrder.startAt) }}
                    </div>
                    <div>
                        <span class="is-description"> {{ translate("notification_center.listing_item.receivers") }}: </span>
                        {{ notificationOrder.actualReceivers }} /
                        {{ notificationOrder.expectedReceivers }}
                    </div>
                    <div>
                        <span class="is-description"> {{ translate("notification_center.listing_item.actual_cost") }}: </span>
                        {{ notificationOrder.actualCostFormatted }} /
                        {{ notificationOrder.expectedCostFormatted }}
                    </div>
                </div>
                <div class="mt-3">
                    <CriteriaSummary :notification-order="notificationOrder" />
                </div>
            </div>
            <div class="column is-narrow is-flex is-align-items-center is-justify-content-center">
                <div class="buttons">
                    <button class="button is-small" @click="openContentModal(notificationOrder.content)">
                        {{ translate("notification_center.listing_item.show_content") }}
                    </button>
                    <LoadingButton
                        :is-loading="cancelInProgress === notificationOrder.id"
                        class="button is-danger is-small"
                        :disabled="isStopRequestBlocked(notificationOrder.status)"
                        @click="cancelNotificationOrder(notificationOrder.id)"
                    >
                        <span class="icon">
                            <i class="fa fa-ban" />
                        </span>
                        <span>
                            {{ translate("common.cancel") }}
                        </span>
                    </LoadingButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import translatorMixin from "../../Common/translatorMixin";
    import { mapState } from "vuex";
    import { eventBus, SHOW_CONTENT_MODAL_OPEN } from "../eventBus";
    import { DateTime } from "luxon";
    import apiMixin from "../../Api/apiMixin";
    import errorHandlerMixin from "../../Common/errorHandlerMixin";
    import LoadingButton from "../../Common/LoadingButton.vue";
    import CriteriaSummary from "./CriteriaSummary.vue";

    export default {
        name: "notification-orders-table",
        components: { CriteriaSummary, LoadingButton },
        mixins: [translatorMixin, apiMixin, errorHandlerMixin],
        data() {
            return {
                //Contains id that is being cancelled.
                cancelInProgress: "",
            };
        },
        computed: {
            ...mapState("main", ["notificationOrders"]),
        },
        methods: {
            openContentModal(content) {
                eventBus.$emit(SHOW_CONTENT_MODAL_OPEN, content);
            },
            formatCreatedAt(value) {
                return DateTime.fromSQL(value, { zone: "UTC" }).toRelative({ locale: window.panelLocale }) ?? "";
            },
            formatStartAt(value) {
                return DateTime.fromSQL(value, { zone: "UTC" }).toRelative({ locale: window.panelLocale }) ?? "";
            },
            translateType(type) {
                return this.translate(`notification_center.create.short.type.` + type);
            },
            translateStatus(status) {
                return this.translate(`notification_center.status.${status}`);
            },
            isStopRequestBlocked(status) {
                return status !== "created";
            },
            getStatusClass(status) {
                switch (status) {
                    case "created":
                        return "has-text-info";
                    case "inProgress":
                        return "has-text-success";
                    case "done":
                        return "has-text-success";
                    case "failed":
                        return "has-text-warning";
                    case "cancelled":
                        return "has-text-danger";
                    case "terminated":
                        return "has-text-danger";
                    default:
                        return "";
                }
            },
            cancelNotificationOrder(id) {
                if (!confirm(this.translate("common.are_you_sure"))) {
                    return;
                }

                this.cancelInProgress = id;

                return this.notificationsCenterApi()
                    .cancelNotificationOrder(id)
                    .then(() => {
                        return this.$store.dispatch("main/refreshNotificationOrders");
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.cancelInProgress = "";
                    });
            },
        },
    };
</script>

<style scoped></style>
